const dummyClick = (event) => {event.preventDefault(); alert('You have clicked element!')};
const mutedClick = (event) => {event.preventDefault(); event.stopPropagation()};
const emptyFunction = () => { return false };

const abbreviatedNumber = (number, decPlaces) => {
  var abbrev = ['k', 'M', 'B', 'T'];
  decPlaces = Math.pow(10, decPlaces);

  for (var i = abbrev.length - 1; i >= 0; i--) {
    var size = Math.pow(10, (i + 1) * 3);
    if (size <= number) {
      var number = Math.floor(number * decPlaces / size) / decPlaces;
      if ((number === 1000) && (i < abbrev.length - 1)) { number = 1; i++; }
      number += abbrev[i];
      break;
    }
  }
  return number;
};

export {dummyClick, abbreviatedNumber, mutedClick, emptyFunction}
